<script setup lang="ts">
import styles from '@/components/loaders/SimpleLoader.module.scss';

export interface Props {
  color?: string | null;
  bgColor?: string;
  size?: number;
  width?: number;
  indeterminate?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  color: styles.noticesProgressColor,
  bgColor: styles.bgColor,
  size: 30,
  width: 3,
  indeterminate: true,
});
</script>

<template>
  <div :class="$style.simpleLoader">
    <!-- TODO -->
    <!-- @vue-ignore -->
    <v-progress-circular
      :indeterminate="props.indeterminate"
      :bg-color="props.bgColor"
      :color="props.color"
      :size="props.size"
      :width="props.width"
    ></v-progress-circular>
  </div>
</template>

<style lang="scss" module src="./SimpleLoader.module.scss"></style>
